import { render } from "./com_cuentas_bancarias.vue?vue&type=template&id=412c49c0&scoped=true"
import script from "./com_cuentas_bancarias.vue?vue&type=script&lang=js"
export * from "./com_cuentas_bancarias.vue?vue&type=script&lang=js"

import "./com_cuentas_bancarias.vue?vue&type=style&index=0&id=412c49c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412c49c0"]])

export default __exports__